import styled from "styled-components";

import { WHITE } from "@/constants/colors";

export const ResultsCountText = styled.div`
  margin-top: 24px;
  width: 100%;
  text-align: left;
  margin-bottom: 8px;
  height: 21px;
`;

export const TransactionSearchResultsContent = styled.div`
  border-radius: 4px;
  width: 100%;
  background-color: ${WHITE};
  margin-bottom: 16px;
  & > div {
    border-radius: 4px;
  }
`;

export const NotAvailable = styled.span`
  font-style: italic;
`;
